<template>
  <TableComp
    :headers="headers"
    :name="$t('global.malware-scans-and-findings')"
    :status="status"
    :number-of-items="getList().length"
    empty-image="magento-malware-scans"
    :empty-bold-message="$t('global.all-clear')"
    :empty-message="$t('global.no-malware-message')"
    :empty-actions="getEmptyActions()"
  >
    <template #content>
      <CardActionContent :buttons="getButtons()">
        <template #description>
          <p>{{ $t("global.malware-scans-description-2") }}</p>
        </template>
      </CardActionContent>
    </template>
    <template v-slot:desktop>
      <TableRow v-for="hit in getList()" :key="hit.id">
        <td class="align-middle">{{ hit.vulnerability }}</td>
        <td class="align-middle text-center">{{ hit.file }}</td>
        <td class="align-middle text-center">{{ getDate(hit) }}</td>
        <template #actionItems>
          <FormCheckbox v-model="selected.checkbox[hit.id]" />
        </template>
      </TableRow>
    </template>
    <template v-slot:mobile>
      <TableMobileRow v-for="hit in getList()" v-bind:key="hit.id">
        <template v-slot:header>
          <div class="d-flex align-items-center">
            <div class="flex-fill">
              {{ hit.vulnerability }}
            </div>
            <div class="d-flex">
              <FormCheckbox v-model="selected.checkbox[hit.id]" />
            </div>
          </div>
        </template>
        <template v-slot:content>
          <div class="row">
            <div class="col">{{ $t("global.file") }}:</div>
            <div class="col break-word">{{ hit.file }}</div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.date") }}:</div>
            <div class="col">{{ getDate(hit) }}</div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import ContactSupport from "@/components/smart/modals/ContactSupport";
import { dateFormat } from "leatherman-js/utils/formatters/time";
import FormCheckbox from "@/components/display/form/FormCheckbox";
import NavLink from "@/classes/NavLink";
import { reactive } from "@vue/composition-api";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import TableRow from "@/components/display/table/TableRow";

export default {
  name: "MagentoMalwareScansTable",
  props: {
    hits: {
      type: Array,
      default: () => null,
    },
    service: {
      type: Object,
      required: true,
    },
    status: {
      type: Object,
      require: true,
    },
  },
  components: {
    CardActionContent,
    FormCheckbox,
    TableComp,
    TableMobileRow,
    TableRow,
  },
  setup(props, { root }) {
    const selected = reactive({ checkbox: {} });
    const headers = [
      new TableHeader(root.$t("global.vulnerability"), undefined),
      new TableHeader(root.$t("global.file"), "justify-content-center"),
      new TableHeader(root.$t("global.date"), "justify-content-center"),
      new TableHeader(),
    ];

    const getButtons = () => [
      new NavLink(
        root.$t("global.start-support-investigation"),
        null,
        openRequestInstallationForm,
        false,
        "primary",
        "epsilon"
      ),
    ];

    const getDate = (item) => dateFormat(item.date);

    const getEmptyActions = () => [
      new NavLink(
        root.$t("global.start-support-investigation"),
        null,
        openRequestInstallationForm,
        false,
        "primaryOutline",
        "epsilon"
      ),
    ];

    const getList = () => props.hits || [];

    const getSelectedPatches = () => {
      return getList().filter((item) => selected.checkbox[item.id]);
    };

    const getTicketBody = () =>
      getSelectedPatches().reduce(
        (acc, hit) => acc + `${getDate(hit)}\n${hit.vulnerability}\n${hit.file}\n\n`,
        `${root.$t("global.please-investigate-malware")}\n\n`
      );

    const openRequestInstallationForm = () =>
      store.dispatch("modals/open", {
        template: ContactSupport,
        data: {
          serviceId: props.service.id,
          subject: root.$t("global.investigate-malware"),
          reply: getTicketBody(),
          department: root.$t("global.support"),
        },
      });

    return {
      getButtons,
      getDate,
      getEmptyActions,
      getList,
      getTicketBody,
      headers,
      selected,
    };
  },
};
</script>
